<template>
  <div>
    <el-card class="box-card" body-style="min-height:74vh;">
      <div slot="header" class="clearfix">
        <div @click="backPage" class="mt-racede-fff-back flex-row-align">
          <i class="el-icon-arrow-left"></i>返回
        </div>
      </div>
      <div>
        <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="190px" size="small" class="demo-ruleForm">
          <el-form-item label="商品：" prop="goodsId">
            <el-select style="width: 420px;" v-model="ruleForm.goodsId" placeholder="请选择商品">
              <el-option v-for="(item,index) in goodsList" :key="index" :label="item.goodsName" :value="item.goodsId"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item v-if="ruleForm.giveawaySpecPageVoList.length > 0" label="选择规格：" prop="goodsSpecId">
            <el-radio-group v-model="ruleForm.goodsSpecId">
                <el-radio style="display: block;margin-top: 10px;" v-for="(item,index) in ruleForm.giveawaySpecPageVoList" :key="index" :label="item.goodsSpecId">{{item.goodsSpecName}}</el-radio>
                <!-- <el-radio :label="6">备选项</el-radio>
                <el-radio :label="9">备选项</el-radio> -->
            </el-radio-group>
            <!-- <div v-for="(item,index) in ruleForm.giveawaySpecPageVoList" :key="index"><el-checkbox v-model="item.isChecked">{{item.goodsSpecName}}</el-checkbox></div> -->
          </el-form-item>
          <el-form-item label="单次赠送数量：" prop="giveawayNumber">
            <el-input style="width: 424px;" v-model="ruleForm.giveawayNumber" placeholder="请输入赠送数量"></el-input>
          </el-form-item>
          <el-form-item label="活动库存：" prop="stockNum">
            <el-input style="width: 424px;" v-model="ruleForm.stockNum" placeholder="请输入活动库存"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" size="medium" @click="saveBtn">保存</el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-card>
  </div>
</template>

<script>
import { queryAllEnableGoodsList, saveGiveawayManage, updateGiveawayManage, fetchGiveawayManageDetailById } from '@/api/giftPromotion'
export default {
  name: 'SeckillAdd',
  data () {
    return {
      imgServer: this.$imgServer,
      baseUrl: this.$baseUrl,
      token:this.$token,
      dataId: this.$route.query.dataId,
      infoId: this.$route.query.infoId,
      goodsList: [],
      ruleForm: {
        goodsId: '',
        goodsSpecId:'',
        giveawayNumber:'',
        stockNum: '',
        giveawaySpecPageVoList:[]
      },
      rules: {
        goodsId: [
          { required: true, message: '请选择商品', trigger: 'blur' }
        ],
        goodsSpecId: [
          { required: true, message: '请选择商品规格', trigger: 'blur' }
        ],
        giveawayNumber: [
          { required: true, message: '请输入赠送数量', trigger: 'blur' }
        ],
        stockNum: [
          { required: true, message: '请输入活动库存', trigger: 'blur' }
        ]
      },
      isOne:1
    }
  },
  watch: {
    'ruleForm.goodsId': {
      handler(newVal, oldVal) {
        var that = this;
        console.log(newVal, oldVal);
        if(that.dataId == '' || (that.dataId != '' && that.isOne == 2)){
          that.goodsList.forEach(function(item){
            if(newVal == item.goodsId){
              that.ruleForm.giveawaySpecPageVoList = item.giveawaySpecPageVoList;
            }
          });
        }
        that.isOne = 2;
      }
    }
  },
  mounted () {
    if (this.$route.query.dataId === '') {
      this.dataId = ''
      this.goodsFun();
    } else {
      let that = this
      fetchGiveawayManageDetailById({ id: that.dataId }).then((res) => {
        if (res.errorCode === '0000') {
          let data = res.data
          that.ruleForm.goodsId = data.goodsId
          that.ruleForm.goodsSpecId = data.goodsSpecId;
          that.ruleForm.giveawayNumber = data.giveawayNumber
          that.ruleForm.stockNum = data.stockNum
          that.goodsFun();
        }
      })
    }
  },
  methods: {
    // 返回上一页
    backPage () {
      this.$router.go(-1)
    },
    // 商品列表数据
    goodsFun(){
      let that = this
      queryAllEnableGoodsList({}).then((res) => {
        if (res.errorCode === '0000') {
          let data = res.data
          if(that.ruleForm.goodsId != ''){
            data.forEach(function(item){
              if(that.ruleForm.goodsId == item.goodsId){
                that.ruleForm.giveawaySpecPageVoList = item.giveawaySpecPageVoList;
              }
            })
          }
          that.goodsList = data;
        }
      })
    },
    // 保存操作
    saveBtn () {
      let that = this
      let dataId = that.dataId
      let infoId = that.infoId
      let goodsId = that.ruleForm.goodsId
      let goodsSpecId = that.ruleForm.goodsSpecId
      let giveawayNumber = that.ruleForm.giveawayNumber
      let stockNum = that.ruleForm.stockNum
      if (goodsId === '') {
        this.$message.error('请选择商品')
        return false
      }
      if (goodsSpecId === '') {
        this.$message.error('请选择商品规格')
        return false
      }
      if (giveawayNumber === '') {
        this.$message.error('请输入赠送数量')
        return false
      }
      if (stockNum === '') {
        this.$message.error('请输入活动库存')
        return false
      }
      let passData = {
        goodsId: goodsId, giveawayId: infoId, goodsSpecId: goodsSpecId, giveawayNumber: giveawayNumber, stockNum: stockNum
      }
      if (dataId !== '') {
        passData.id = dataId;
        updateGiveawayManage(passData).then((res) => {
          that.backDataFun(res)
        })
      }else{
        saveGiveawayManage(passData).then((res) => {
         that.backDataFun(res)
        })
      }
    },
    backDataFun(res){
      var that = this
      if (res.errorCode === '0000') {
        this.$message({
          message: res.msg,
          type: 'success',
          onClose () {
            that.$router.go(-1)
          }
        })
      }
      if (res.errorCode === '1001') {
        this.$message.error(res.msg)
      }
    }
  }
}
</script>

<style>
 .el-header {
    background-color: #fff;
  }
</style>



// WEBPACK FOOTER //
// src/pages/market/GiftPromotion/GiftManageAdd.vue